import * as React from 'react';
import * as Food from '../../domain/Food';
import Energy from './Energy';
import NutrientDensity from './NutrientDensity';

type GraphProps = {
  food: Food.Food,
  foodWithNutrients: Food.FoodWithNutrients | null
};
type GraphState = {
  grams: number,
  servings: number
};

function weightName(weight: Food.Weight): string {
  return (weight.desc === 'grams' ?
    weight.amount * weight.grams
  : weight.amount
  ) + ' ' + weight.desc;
}

class Graphs extends React.Component<GraphProps, GraphState> {
  // TODO $('#message-box').hide();
  // TODO $('#start-messages').remove();
  constructor(props: GraphProps) {
    super(props);
    this.state = {grams: Food.GRAMS_GIVEN, servings: 1};
    this.servingsChange = this.servingsChange.bind(this);
    this.selectWeight = this.selectWeight.bind(this);
  }

  servingsChange(event: React.FormEvent<HTMLInputElement>): void {
    let servings = parseInt(event.currentTarget.value, 10);
    if (servings > 0) {
      this.setState({servings: servings});
    }
  }

  selectWeight(event: React.FormEvent<HTMLSelectElement>): void {
    let grams = parseInt(event.currentTarget.value, 10);
    if (grams > 0) {
      this.setState({grams: grams});
    }
  }

  render() {
    const { food, foodWithNutrients } = this.props;
    const { servings } = this.state;
    const weights = ((foodWithNutrients !== null) && foodWithNutrients.weights) || [];

    return (
      <div id="below-search">
        <p id="food-title-box">
          <span id="food-title">
            {food.longDesc} - {food.foodGroup}
          </span>
        </p>
        <div id="below-food-title" />
        <form id="measurement">
          { (weights.length === 0) && (
            <div>
              <span id="100-only">100 grams</span>
            </div>
          )}
          { (weights.length > 0) && (
            <div className="inline-block">
              <select name="weight" onChange={this.selectWeight}>
                <option key={100} value={100}>100 grams</option>
                { weights.map((weight) =>
                  <option key={weight.grams} value={weight.grams}>{weightName(weight)}</option>
                ) }
              </select>
            </div>
          ) }
          <label>
            Servings
            <input
              id="servings"
              name="servings"
              type="number"
              value={servings}
              onChange={this.servingsChange}
            />
          </label>
        </form>

        <div id="message-box">
          <div id="start-messages">
            { /*
            <!--[if lt IE 9]>
            <p id="ie-deprecated">Modern web browsers will display a wonderful graph here. You might want to try using
              <a href="http://www.google.com/chrome">Google Chrome</a>
            </p>
            <![endif]-->
            */ }
          </div>
        </div>

        <div id="data-display">
          <Energy food={this.props.food} grams={this.state.grams} servings={servings} />
          { (foodWithNutrients !== null) && (
            <NutrientDensity
              foodWithNutrients={foodWithNutrients}
              grams={this.state.grams}
              servings={servings}
            />
          ) }

          <table id="extended-nutrients" className="bar-graph" style={{display: 'none'}}>
            <thead>
              <tr>
                <th>nutrient</th>
                <th>amount</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    );
  }
}

export default Graphs;



// WEBPACK FOOTER //
// ./src/feature/graphs/Graphs.tsx